import React from 'react';
import Features from './Features';
import Advantages from './Advantages';
import { FAQ } from '../FAQ/faqs';
import Footer from '../Footer';



function KnowledgeManagement() {
  return (
    <>
<Features docname="Knowledge Management and WiKi"/>
<Advantages docname="Knowledge Management and WiKi"/>
<FAQ category="About Accxchange"/>
<Footer segment="Smarty Home"/>
    </>
  );
}

export default KnowledgeManagement;
